import { Component, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'vx-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <header class="nav">
      <a routerLink="/" class="brand" (click)="close()" aria-label="VaulTriX home">
        <img src="assets/brand/vaultrix-logo.jpeg" alt="VaulTriX">
      </a>
      <button class="hamburger" type="button" (click)="open.set(!open())" [attr.aria-expanded]="open()" aria-label="Apri menu">
        <span></span><span></span><span></span>
      </button>
      <nav [class.open]="open()">
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="close()">Home</a>
        <a routerLink="/soluzioni" routerLinkActive="active" (click)="close()">Soluzioni</a>
        <a routerLink="/come-funziona" routerLinkActive="active" (click)="close()">Come funziona</a>
      </nav>
    </header>
  `,
  styles: [`
    .nav {
      position: sticky;
      top: 0;
      z-index: 30;
      min-height: 78px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px 0 46px;
      background: #fff;
      box-shadow: 0 1px 0 rgba(32, 18, 67, 0.08);
    }
    .brand { display: inline-flex; align-items: center; }
    .brand img {
      width: 74px;
      height: 52px;
      object-fit: contain;
      mix-blend-mode: multiply;
    }
    nav {
      display: flex;
      align-items: center;
      gap: 22px;
    }
    nav a {
      padding: 0.7rem 0.25rem;
      border-radius: 8px;
      color: #0f082c;
      font-weight: 800;
      font-size: 1rem;
    }
    nav a.active,
    nav a:hover {
      color: #5b35a8;
    }
    .nav-cta {
      color: white !important;
      padding: 0.82rem 1.55rem !important;
      border-radius: 5px;
      background: #673ab7;
    }
    .hamburger {
      display: none;
      border: 0;
      background: transparent;
      cursor: pointer;
      width: 42px;
      height: 42px;
      border-radius: 10px;
      place-items: center;
      gap: 4px;
    }
    .hamburger span {
      display: block;
      width: 20px;
      height: 2px;
      border-radius: 99px;
      background: var(--vx-text);
    }
    @media (max-width: 820px) {
      .nav {
        min-height: 70px;
        padding: 0 16px;
      }
      .hamburger { display: grid; }
      nav {
        position: absolute;
        left: 12px;
        right: 12px;
        top: 76px;
        display: none;
        flex-direction: column;
        align-items: stretch;
        padding: 12px;
        border-radius: 16px;
        background: white;
        box-shadow: var(--vx-shadow);
      }
      nav.open { display: flex; }
    }
  `]
})
export class NavbarComponent {
  protected readonly open = signal(false);

  protected close() {
    this.open.set(false);
  }
}
